
const MapModal = () => import('~/components/Car/MapModal.vue');

export default {
  components: { MapModal },
  props: {
    url: {
      type: String,
      default: undefined,
    },
  },
};
